import React from 'react';
import { useMi } from '../context/MiContext';
import { useLoading } from '../context/LoadingContext';
import MiPresence from './MiPresence'; // NEW Consolidated Presence
import MiSystem from './MiSystem';
import UnifiedLoader from './ui/UnifiedLoader';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * MiSystemShell — The AI-First OS Shell (Phase 2 Consolidated)
 * Enforces SINGLE MI Policy.
 */
export default function MiSystemShell({ children }) {
  const { isLoading: isGlobalLoading } = useLoading();
  const { 
    mi, 
    chatMessages, 
    setChatMessages,
    activeTab,
    setActiveTab,
    isAuthenticated,
    isOnboardingActive,
    chatInput,
    setChatInput,
    isChatOpen,
    isChatSending,
    credits,
    isProcessing,
    coachStatus,
    sensiStatus,
    syncMiState,
    handleChatRef
  } = useMi();

  const toggleChat = () => syncMiState({ isChatOpen: !isChatOpen });
  
  const handleChatFromShell = (msg, opts) => {
    if (handleChatRef.current) {
      handleChatRef.current(msg, opts);
    }
  };

  // Centralized loading check
  const shouldRenderMiUi = Boolean(isAuthenticated) && !isOnboardingActive;
  const showLoader = shouldRenderMiUi && isGlobalLoading;

  return (
    <div className="mi-root" style={{ 
      position: 'relative', 
      width: '100%', 
      height: '100dvh', 
      overflow: 'hidden',
      background: 'var(--gph-bg, #050505)'
    }}>
      
      {/* ── App Content Layer (The Tools) ── */}
      <div className="mi-shell-content" style={{ 
        position: 'relative', 
        width: '100%', 
        height: '100%', 
        zIndex: 'var(--z-content)',
        overflow: 'hidden'
      }}>
        {children}
      </div>

      {/* ── Global AI Systems Layer (The Shell) ── */}
      <div className="mi-shell-ui-layer" style={{ 
        position: 'fixed', 
        inset: 0, 
        zIndex: 'var(--z-mi)', 
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        
        {/* 
          [REMOVED IN VISUAL OVERHAUL]
          Global AI Presence & Chat Engine visually disabled.
          Context and state management (useMi) remain fully functional in background.
        */}
        {/* {shouldRenderMiUi && ( ... )} */}

        {/* Global System Loaders removed for conversational inline loading state */}
      </div>

    </div>
  );
}
